<template>
  <q-page padding view="lhh LpR lff" class='row d-flex full-width' style="min-height: unset">
    <div v-for="(item,index) in menu" :key="index" class='col-12 col-sm-4 col-md-3 q-pa-md'>
      <q-btn class='full-width my-card relative-position' :style="'margin: 0 auto;overflow:hidden; min-height:150px;color:white;background:'+colors[index]" :to='item.ref'>
        <q-card-section class='full-width'>
          <div class='text-h5 text-right'>{{item.name}}
          </div>
        </q-card-section>
        <q-card-section class='text-left absolute q-my-xl' style='left:-8%;top:20%'>
          <q-icon :name='item.icon' style='font-size: 7em; opacity:0.3' />
        </q-card-section>
      </q-btn>
    </div>
  </q-page>
</template>

<script>
export default {
  data() {
    return {
      menu: [
        { ref: '/plans', name: 'Kế hoạch', icon: 'assignment'},
        { ref: '/statistics', name: 'Báo cáo', icon: 'trending_up'},
        { ref: '/timekeeping', name: 'Chấm công', icon: 'assignment_ind'},
        { ref: '/reports', name: 'Chăm sóc lô', icon: 'assessment'},
        // { ref: '/harvest', name: 'Chăm sóc buồng', icon: 'local_florist'},
        { ref: '/manage-order', name: 'Đơn hàng', icon: 'receipt'},
        { ref: '/categories', name: 'Danh mục', icon: 'category'},
      ],
      colors: ['#00a152', '#f44336', '#2196f3', '#9c27b0', '#e91e63', '#f57f17', '#795548'],
    }
  },
  computed: {
    permission () {
      return this.$store.getters.permission
    }
  },
  created() {
    this.checkPerm(this.permission)
  },
  watch: {
    permission: function (newValue) {
      this.checkPerm(newValue)
    }
  },
  methods: {
    checkPerm(value) {
      if(!value) return
      let accept = ['F1M', 'F2M', 'F3M', 'F4M', 'F5M', 'BOM']
      if (value && this._.intersection(accept, Object.keys(value.roles)).length > 0) {
        this.menu = this.menu
      } else if (value && this._.intersection(accept, Object.keys(value.roles)).length == 0) {
        this.menu = this.menu.slice(0, this.menu.length - 1)
      } else {
        this.menu = null
      }
    }
  },
}
</script>

<style scoped>
.wrap {
  max-width: 1200px;
  text-align: center;
  margin: auto;
}
#video {
  width:100%;
  max-width: 640px;
}
</style>
